import { useAppDispatch, useAppSelectorShallow } from 'store/hooks';
import COLOR from 'constants/color';
import { Star } from 'assets/icons/revamp';
import Card from 'components/ui/Card';
import { t } from 'services/i18n.service';
import {
  updateMoreOptionActivityCutoffTime,
  updateMoreOptionPriority
} from 'store/reducer/modal/slice';
import { PRIORITY_OPTION } from 'constants/general';
import { moreOptionModalActivitySelector } from 'store/reducer/modal/more-options.modal.selectors';

const PriorityLevel: React.FC = () => {
  const dispatch = useAppDispatch();
  const activity = useAppSelectorShallow(moreOptionModalActivitySelector);

  const priorityOptions = [
    { label: t('tabs_revamp.timing_tab.must_do'), value: PRIORITY_OPTION.HIGH },
    {
      label: t('tabs_revamp.timing_tab.optional'),
      value: PRIORITY_OPTION.STANDARD
    }
  ];

  const handlePriorityChange = (value: string) => {
    dispatch(updateMoreOptionPriority(value));
    value === PRIORITY_OPTION.STANDARD &&
      dispatch(updateMoreOptionActivityCutoffTime(undefined));
  };

  return (
    <Card className='flex flex-col ~gap-3/4'>
      <div className='flex items-start ~gap-2/3'>
        <Star
          className='~w-4/6 ~h-4/6 mt-0.5'
          fill={COLOR.PRIMARY.LIGHT_600}
          fillDarkMode={COLOR.PRIMARY.DARK_600}
        />
        <div className='flex-1 flex flex-col ~gap-1/2'>
          <h3 className='~text-xs/base font-semibold text-black dark:text-white'>
            {t('tabs_revamp.timing_tab.priority_level')}
          </h3>
          <p className='~text-xs/sm text-gray-600 dark:text-gray-400'>
            {t('tabs_revamp.timing_tab.priority_level_description')}
          </p>
        </div>
      </div>
      <div className='flex items-center ~gap-4/6 ~ml-0/0'>
        {priorityOptions.map((option) => (
          <label
            key={option.value}
            className='flex items-center ~gap-2/3 cursor-pointer'>
            <input
              type='radio'
              name='priorityLevel'
              value={option.value}
              checked={
                (activity.priority || PRIORITY_OPTION.HIGH) === option.value
              }
              onChange={() => handlePriorityChange(option.value)}
              className='w-4 h-4 text-primary-900 focus:ring-primary-500 focus:ring-2 border-gray-300 dark:border-gray-600'
            />
            <span className='~text-sm/base text-black dark:text-white'>
              {option.label}
            </span>
          </label>
        ))}
      </div>
    </Card>
  );
};

export default PriorityLevel;
